var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.htmlText)?_c(_vm.tag,{tag:"component",style:(_vm.style)},[_vm._t("default")],2):_c(_vm.tag,{tag:"component",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.htmlText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }